import { render, staticRenderFns } from "./FmaTile.vue?vue&type=template&id=986739a2&scoped=true"
import script from "./FmaTile.vue?vue&type=script&lang=js"
export * from "./FmaTile.vue?vue&type=script&lang=js"
import style0 from "./FmaTile.vue?vue&type=style&index=0&id=986739a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986739a2",
  null
  
)

export default component.exports